<template>
    <div class="account">
        <el-tabs v-model="activeName" type="border-card" @tab-click="tabClick" style="margin-top: 10px">
            <el-tab-pane label="全部" name="1">
                <vCooperativePriceListComponent1 v-if="flag1" :postList="postList1"></vCooperativePriceListComponent1>
            </el-tab-pane>
            <el-tab-pane label="待我审批" name="2">
                <span slot="label">
                    待我审批 <el-badge v-show="activeValue2 > 0" :max="99" :value="activeValue2" class="item"> </el-badge
                ></span>
                <vCooperativePriceListComponent2
                    v-if="flag2"
                    :postList="postList2"
                    @isCountShow="isCountShow"
                ></vCooperativePriceListComponent2>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import vCooperativePriceListComponent1 from '../../listComponent/riskcontrol/cooperativeprice/cooperativePriceListComponent.vue';
import vCooperativePriceListComponent2 from '../../listComponent/riskcontrol/cooperativeprice/cooperativePriceListComponent.vue';
export default {
    name: 'cooperativePriceList',
    components: {
        vCooperativePriceListComponent1,
        vCooperativePriceListComponent2
    },
    data() {
        return {
            activeValue2: 0,
            activeName: '1',
            flag1: false,
            flag2: false,
            postList1: {
                headerTitle: false,
                code: true,
                province_rid: true,
                product_rid: true,
                city_rid: true,
                partner_rid: true,
                feature_code: true,
                timeliness: true,
                approval_status: true,
                demander_name: true,
                partner_scheme_rid: true,
                date: true,
                addBtn: true,
                okBtn: false,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true,
                params: {
                    tab_type: 1
                }
            },
            postList2: {
                headerTitle: false,
                code: true,
                province_rid: true,
                product_rid: true,
                city_rid: true,
                partner_rid: true,
                feature_code: true,
                demander_name: true,
                partner_scheme_rid: true,
                timeliness: true,
                approval_status: false,
                date: true,
                addBtn: true,
                okBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true,
                params: {
                    tab_type: 2
                }
            }
        };
    },
    mounted() {
        this.getCount(); //获取待我审批数量
        this.flag1 = false;
        this.$nextTick(() => {
            this.flag1 = true;
        });
    },
    methods: {
        //子组件审批完毕
        isCountShow(data) {
            this.getCount(); //获取待我审批数量
        },
        //切换tab
        tabClick(tab) {
            this.getCount();
            if (tab.name == 1) {
                this.flag1 = false;
                this.$nextTick(() => {
                    this.flag1 = true;
                });
            } else {
                this.flag2 = false;
                this.$nextTick(() => {
                    this.flag2 = true;
                });
            }
        },
        //获取待我审批数量
        getCount() {
            var params = {
                page: this.page,
                row: this.row,
                tab_type: 2
            };
            this.$api
                .partnerPriceLists(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.activeValue2 = res.data.total;
                    }
                })
                .catch((error) => {
                    
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>